import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoredScoreRowComponent } from './stored-score-row.component';

@NgModule({
	imports: [CommonModule, NgbModule],
	declarations: [StoredScoreRowComponent],
	exports: [StoredScoreRowComponent],
})
export class StoredScoreRowModule {}
